
import React from "react";
import { getToolRoute } from "@/utils/toolRoutes";
import { useNavigate } from "react-router-dom";

type ActionLink = {
  text: string;
  toolName: string;
  color?: string; // Couleur optionnelle personnalisée
};

const actionLinks: ActionLink[] = [
  { text: "Générer son persona", toolName: "GenPersona", color: "#E5DEFF" },
  { text: "Visualiser son ROI", toolName: "ROIQuick", color: "#FFF5E5" },
  { text: "Réduire une URL", toolName: "ShortaTrack", color: "#E5F6FF" },
  { text: "Analyser son objet d'email", toolName: "EmailScore", color: "#E5FFED" },
  { text: "Compresser une image", toolName: "CompressaPic", color: "#FFE5E5" },
  { text: "Vérifier la vitesse de son site", toolName: "PageSpeedCheck", color: "#F5E5FF" },
  { text: "Créer un QR Code", toolName: "QRna", color: "#E5FEFF" },
  { text: "Créer un formulaire", toolName: "FormuGen", color: "#F5FFE5" },
  { text: "Analyser ses mots-clés", toolName: "KeywordCheck", color: "#FFE5F5" },
  { text: "Calculer sa rentabilité", toolName: "ProfitPilot", color: "#E5FFF5" },
  { text: "Analyser un entonnoir", toolName: "FunnelFlow", color: "#F5FFE5" },
  { text: "Générer un nom d'entreprise", toolName: "BizNameGen", color: "#F5E5FF" },
  { text: "Créer des UTM", toolName: "UTMagic", color: "#E5F5FF" },
  { text: "Prévisualiser snippets", toolName: "SnippetView", color: "#FFE5E5" },
];

export const ActionLinks: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigate = (toolName: string) => {
    const route = getToolRoute(toolName);
    navigate(route);
  };

  return (
    <div className="w-full overflow-x-auto py-2">
      <div className="flex flex-wrap justify-center gap-2 w-full">
        {actionLinks.map((link) => {
          return (
            <button
              key={link.toolName}
              onClick={() => handleNavigate(link.toolName)}
              className="text-sm font-medium rounded-full px-3 py-1.5 
                border-2 border-black transition-all hover:-translate-y-0.5"
              style={{
                backgroundColor: link.color || "#E5DEFF",
                color: "#000000",
                boxShadow: "0 2px 0 0 rgba(0, 0, 0, 0.3)"
              }}
            >
              {link.text}
            </button>
          );
        })}
      </div>
    </div>
  );
};
